let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://uniops.moleawiz.com/ws";
export const logOutTarget = "";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://uniops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://uniops.moleawiz.com"
} else if (environment === "staging") {
  baseUrl =
    "https://uniops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://uniops.moleawiz.com"
} else {
  baseUrl =
    "https://uniops.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://uniops.moleawiz.com"
}

export { baseUrlOrigin };
export default baseUrl;
